import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { updateLoadingState } from '@sales-center/common'
import { refreshToken } from '@user/store/authorization/api'
import {
  selectUserAuthenticated,
  setUserAuthenticated,
} from '@user/store/authorization/userSlice'
import { useSelector } from 'react-redux'
import { getAuthHeader } from '@user/store/services/crud'

export const useRefreshTokenOnMount = () => {
  const dispatch = useAppDispatch()

  const [loading, setLoading] = useState(true)
  const authenticated = useSelector(selectUserAuthenticated)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      dispatch(updateLoadingState('visible'))
      try {
        const response = await dispatch(refreshToken())

        if (mounted) {
          if (refreshToken.fulfilled.match(response)) {
            dispatch(updateLoadingState('hidden'))
            dispatch(setUserAuthenticated(true))
            setLoading(false)
          } else {
            dispatch(updateLoadingState('hidden'))
            dispatch(setUserAuthenticated(false))
            setLoading(false)
          }
        }
      } catch {
        if (mounted) {
          dispatch(updateLoadingState('hidden'))
          dispatch(setUserAuthenticated(false))
          setLoading(false)
        }
      }
    }

    const token = getAuthHeader()

    if (!!token) {
      execute()
    } else {
      dispatch(setUserAuthenticated(false))
      setLoading(false)
    }

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { loading, authenticated }
}
